import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';

import AvalancheDashboardPageFilters from '@awp/components/AvalancheMonitor/PageFilters';
import AvalancheVisualContainer from '@awp/components/AvalancheMonitor/GraphView/AvalancheVisualContainer';
import AvalancheDetailContainer from '@awp/components/AvalancheMonitor/GraphView/AvalancheDetailContainer';
import { fetchPrograms } from '@stores/avalancheDashboardViewPageSlice';
import { AwpContainer } from '../Common/AwpContainer';

const AvalancheDashboardPage = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(fetchPrograms());
  }, []);

  return (
    <AwpContainer>
      <AvalancheDashboardPageFilters />
      <AvalancheVisualContainer id={`visual-container-id`} key={`visual-container-id-${1}`} />
      <AvalancheDetailContainer />
    </AwpContainer>
  );
};

export default AvalancheDashboardPage;
